import axios from '../../../../shared/axios';

import * as actionTypes from '../constants/sms-setting';

import { AppDispatch } from '../../../../store';
import { validateObj } from '../../../../shared/utils';

import { SaveSmsSettingRequest, SmsSettingModel } from '../../models';

const getSmsSettingStart = () => {
  return {
    type: actionTypes.SMS_SETTING_GET_SMS_SETTING_START,
  };
};

const getSmsSettingSuccess = (data: SmsSettingModel) => {
  return {
    type: actionTypes.SMS_SETTING_GET_SMS_SETTING_SUCCESS,
    data,
  };
};

const getSmsSettingFail = (error: any) => {
  return {
    type: actionTypes.SMS_SETTING_GET_SMS_SETTING_FAIL,
    error,
  };
};

export const getSmsSetting = () => {
  return (dispatch: AppDispatch) => {
    return new Promise<SmsSettingModel>((resolve, reject) => {
      dispatch(getSmsSettingStart());

      const url = `/sms-setting/get-sms-setting`;

      axios
        .get(url)
        .then((response) => {
          dispatch(getSmsSettingSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getSmsSettingFail(err));
          reject(err);
        });
    });
  };
};

const saveSmsSettingStart = () => {
  return {
    type: actionTypes.SMS_SETTING_SAVE_SMS_SETTING_START,
  };
};

const saveSmsSettingSuccess = (data: boolean) => {
  return {
    type: actionTypes.SMS_SETTING_SAVE_SMS_SETTING_SUCCESS,
    data,
  };
};

const saveSmsSettingFail = (error: any) => {
  return {
    type: actionTypes.SMS_SETTING_SAVE_SMS_SETTING_FAIL,
    error,
  };
};

export const saveSmsSetting = (params: SaveSmsSettingRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<boolean>((resolve, reject) => {
      dispatch(saveSmsSettingStart());

      const url = `/sms-setting/save-sms-setting`;

      axios
        .post(url, validateObj(params))
        .then((response) => {
          dispatch(saveSmsSettingSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(saveSmsSettingFail(err));
          reject(err);
        });
    });
  };
};
